import { useEffect, useState, type ReactNode } from "react";
import { errorMessage } from "../../api/client";
import { ErrorText, FullScreenLoader } from "../../components/ui";

export function useLoad<T>(loader: () => Promise<T>): { data: T | null; error: string | null } {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    loader()
      .then((d) => alive && setData(d))
      .catch((e) => alive && setError(errorMessage(e)));
    return () => {
      alive = false;
    };
  }, [loader]);
  return { data, error };
}

export function DataTable({ headers, children, testId, empty }: { headers: string[]; children: ReactNode; testId: string; empty: boolean }) {
  return (
    <div className="overflow-x-auto rounded-sm border border-white/10">
      <table data-testid={testId} className="w-full min-w-[640px] text-left text-sm">
        <thead className="bg-white/[0.03]">
          <tr>
            {headers.map((h, i) => (
              <th key={`${i}-${h}`} className="label-caps px-5 py-3 font-semibold text-zinc-400">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-white/5">{children}</tbody>
      </table>
      {empty && <p data-testid={`${testId}-empty`} className="px-5 py-10 text-center text-sm text-zinc-500">No records yet.</p>}
    </div>
  );
}

export function LoadState({ error, loading, testId }: { error: string | null; loading: boolean; testId: string }) {
  if (error) return <ErrorText message={error} testId={testId} />;
  if (loading) return <FullScreenLoader />;
  return null;
}
